import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { EquipmentDocumentResponse } from '@vi-iot/client';

import { InstallationDetailsStore } from '@store';

@Component({
  selector: 'app-maintenance-checklist',
  templateUrl: './maintenance-checklist.component.html',
  styleUrls: ['./maintenance-checklist.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaintenanceChecklistComponent implements OnInit {
  maintenanceChecklistItem$: Observable<EquipmentDocumentResponse[]>;

  constructor(
    public installationDetailsStore: InstallationDetailsStore,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.installationDetailsStore.getMaintenanceChecklist();
    this.maintenanceChecklistItem$ = this.installationDetailsStore.maintenanceChecklist$;
    this.cdr.markForCheck();
  }
}
